import { render } from "./InstantLayoutGenerator.vue?vue&type=template&id=701b1d16"
import script from "./InstantLayoutGenerator.vue?vue&type=script&lang=js"
export * from "./InstantLayoutGenerator.vue?vue&type=script&lang=js"

import "./InstantLayoutGenerator.vue?vue&type=style&index=0&id=701b1d16&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__